import React from 'react';
import { useNavigate } from 'react-router-dom';

import { LandingActivityArrow } from 'assets/svg/landing/landingIcons';
import { RGM_HOME_RECENT_ACTIVITIES, rgmRecentActivityRowTestId } from 'constants/landingTestIds';
import useFetchRecentActivity from 'hooks/landing/useFetchRecentActivity';
import { RecentActivityItem } from 'types/landing';
import { isSafePostLoginPath } from 'utils/postLoginRedirect';

function RecentActivityRow({ activity, onOpen }: { activity: RecentActivityItem; onOpen: (route: string) => void }) {
    return (
        <button
            type="button"
            data-testid={rgmRecentActivityRowTestId(activity.id)}
            className="flex w-full items-center justify-between gap-3 rounded-lg border border-filterV2Border bg-white px-3 py-2.5 text-left"
            onClick={() => onOpen(activity.route)}
        >
            <div className="flex flex-col gap-0.5 overflow-hidden">
                <p className="truncate font-xs font-medium leading-[normal] text-filterV2TextPrimary">
                    {activity.title}
                </p>
                <div className="flex items-center gap-1.5 font-xxs font-normal leading-[normal] text-navV2TextMuted">
                    <span className="truncate">{activity.moduleLabel}</span>
                    <span className="px-1">•</span>
                    <span className="whitespace-nowrap">{activity.timeLabel}</span>
                </div>
            </div>
            <LandingActivityArrow className="size-4 shrink-0" />
        </button>
    );
}

function RecentActivities() {
    const navigate = useNavigate();
    const { activities } = useFetchRecentActivity();

    const onOpen = (route: string) => {
        if (!isSafePostLoginPath(route)) return;
        navigate(route);
    };

    return (
        <section data-testid={RGM_HOME_RECENT_ACTIVITIES} className="flex min-w-px flex-[1_0_0] flex-col gap-3">
            <p className="font-sm font-medium leading-[1.2] text-blackTitle">RECENT ACTIVITIES</p>

            <div className="flex flex-col gap-3 rounded-lg border border-filterV2Border bg-white p-[17px]">
                {activities.length === 0 ? (
                    <p className="font-xs font-normal text-navV2TextMuted">Pages you visit will appear here.</p>
                ) : (
                    activities.map((activity) => (
                        <RecentActivityRow key={activity.id} activity={activity} onOpen={onOpen} />
                    ))
                )}
            </div>
        </section>
    );
}

export default RecentActivities;
